export default __webpack_public_path__ + "static/media/stake-more-mlt-bnb.9e0f9134.svg";